// extracted by mini-css-extract-plugin
export default {"cls1":"SourceAccountFormFields-HeadingSkeleton_cls1__2o+dt","cls2":"SourceAccountFormFields-HeadingSkeleton_cls2__ZZvzJ SourceAccountFormFields-HeadingSkeleton_cls1__2o+dt"};